import {createFileRoute} from '@tanstack/react-router'

import {addToOrderDraftKey} from 'src/jobs/create-job-storage'
import {JobEntryPage} from 'src/jobs/job-entry/job-entry-page'
import {orderLabel} from 'src/jobs/order-plus/order-label'
import {OrderPageFrame} from 'src/jobs/order-plus/order-page-frame'
import {validateOrderPlusSearch} from 'src/jobs/order-plus/order-plus-search'
import {pickAddJobSource} from 'src/jobs/order-plus/pick-source-job'

export const Route = createFileRoute('/_app/projects/$projectId/jobs/add')({
    validateSearch: validateOrderPlusSearch,
    component: AddToOrderRoute,
})

function AddToOrderRoute() {
    const {projectId} = Route.useParams()
    const {from} = Route.useSearch()
    return (
        <OrderPageFrame
            projectId={projectId}
            title={(order) => `Add to order ${orderLabel(order)}`}
            description="Adds the next job to this order"
        >
            {(order, {canEdit}) => {
                const sourceJobId = from ?? pickAddJobSource(order.jobs)?.id ?? null
                return (
                    <JobEntryPage
                        key={addToOrderDraftKey(order.id, sourceJobId)}
                        order={{
                            projectId: order.id,
                            orderLabel: orderLabel(order),
                            customerId: order.customerId,
                            customerName: order.customerName,
                            dispatchYardId: order.dispatchYardId ?? null,
                            sourceJobId,
                        }}
                        readOnly={!canEdit}
                    />
                )
            }}
        </OrderPageFrame>
    )
}
